<template>
	<div :class="classNames+ 'card_list'" class="">
		<useTable :searchForm="searchForm" :httprequest="httprequest" ref="useTable" :headerList="headerData" :showEmptyTable="false"></useTable>
		<!-- 关联课程查看 -->
		<cardDialog v-model="showCardDialog" :cardFormInfo="cardFormInfo" @getCardList="getCardList"></cardDialog>
	</div>
</template>
<script>
import useTable from '@/components/useTable/useTable.vue'
import { mapActions } from 'vuex'
import { ElTooltip } from 'element-ui'
import cardDialog from './cardDialog.vue'
export default {
	data() {
		const statusList = [
			{
				label: '全部',
				value: ''
			},
			
			{
				label: '审核中',
				value: 1
			},
			{
				label: '审核驳回',
				value: 3
			},
			{
				label: '审核通过',
				value: 2
			},
		]
		return {
			classNames: 'cardList',
			showCardDialog: false,
			searchForm: [
				{
					defaultValue: '',
					label: '卡片标题:',
				    Component: 'el-input',
					prop: 'title',
				    componentProps: {
				        placeholder: '请输入卡片标题'
				    }
				},
				{
					defaultValue: '',
					label: '卡片状态:',
                    Component: 'el-select',
					prop: 'audit_status',
                    componentProps: {
                        placeholder: '全部'
                    },
                    childSlot: statusList.map(item => {
						return {
							Component: 'el-option',
							componentProps: {
								label: item.label,
								value: item.value,
								key: item.value
							}
						}
					})
				},
				{
					Component: 'el-button',
					span: 3,
				    componentProps: {
				       type: "primary"
				    },
				    renderHTML: () => {
				        return '查询'
				    },
				    on: {
				        click: this.getCardList
				    }
				},
				{
					Component: 'el-button',
					span: 4,
				    componentProps: {
				       type: "primary"
				    },
				    renderHTML: () => {
				        return '+创建卡片'
				    },
				    on: {
				        click: this.addCardModal
				    }
				},
			],
			headerData: [
				{
					props: {
                        prop: 'id',
                        label: '卡片ID',
                        width: 80
                    }
				},
				{
					props: {
				        prop: 'card_type_desc',
				        label: '卡片类型',
				        width: 100
				    }
				},
				{
					props: {
				        prop: 'title',
				        label: '卡片标题',
				        width: 150
				    }
				},
				{
					props: {
                        prop: 'card_status',
                        label: '卡片状态'
                    }
				},
				{
					props: {
				        prop: 'reject',
				        label: '驳回原因',
				        width: 120
				    },
					render:(h, {row})=> {
						if(row.status === 1) {
							return <el-tooltip content={row.reject} placement="top" style="width: 200px"><span>{row.reject}</span></el-tooltip> 
						}
					}
				},
				{
					props: {
				        prop: 'created_time',
				        label: '创建时间',
				        width: 180
				    }
				},
				{
					props: {
				        prop: 'created_time',
				        label: '更新时间',
				        width: 180
				    }
				},
                {
                    props: {
                        label: '操作',
                        width: 220
                    },
                    render:(h, scope)=> {
                        return (
							<div>
							    <span class={this.commonName+'_operation_title'} onClick={this.cardShowFun.bind(this,scope.row)}>查看</span>
								<span class={this.commonName+'_operation_title'} onClick={this.cardEditFun.bind(this,scope.row)}>编辑</span>
								<span class={this.commonName+'_operation_title'} onClick={this.cardDeleteFun.bind(this,scope.row)}>删除</span>
								<span class={this.commonName+'_operation_title'} onClick={this.cardInfoDetailFun.bind(this,scope.row)}>信息收集</span>
							</div>
						)
                    }
                }
			],
			cardFormInfo:{},
		}
	},
	components: {
		useTable,
		cardDialog
	},
	methods: {
		...mapActions('dymessage', ['cardsList','cardsDel']),
		getCardList() {
			console.log('getCardList')
			this.$refs.useTable.getRequestRes()
		},
		addCardModal() {
			this.cardFormInfo = Object.assign({}, {
				id: '',
				author_id:'',
				card_type: 1,
				open_card_id: '',
				title: '',
				image: '',
				content: '',
				media_id: '',
				components: [],
				action_type: 4,
				jump_url: '',
				button_name: '',
				audit_status: 0,
				reject: '',
				status: '',
				card_status: ''
			})
			this.showCardDialog = true
		},
		cardEditFun(data) {
			const cardFormInfo = Object.assign({},data)
			if(cardFormInfo.components){
				let components = cardFormInfo.components.split(',')
				cardFormInfo.components = components.map((item) => Number(item))
			} else {
				cardFormInfo.components = []
			}
			this.cardFormInfo = cardFormInfo
			this.cardFormInfo.cardFormInfoShow = false
			this.showCardDialog = true
		},
		cardShowFun(data) {
			const cardFormInfo = Object.assign({},data)
			if(cardFormInfo.components){
				let components = cardFormInfo.components.split(',')
				cardFormInfo.components = components.map((item) => Number(item))
			} else {
				cardFormInfo.components = []
			}
			this.cardFormInfo = cardFormInfo
			this.cardFormInfo.cardFormInfoShow = true
			console.log(this.cardFormInfo)
			this.showCardDialog = true
		},
		cardInfoDetailFun(data) {
			this.$router.push(this.staticPath + 'cardinfolist/' + data.id)
		},
		async cardDeleteFun(data){
			this.$confirm(`确定要删除吗?`, '提示', {
			    confirmButtonText: '确定',
			    cancelButtonText: '取消',
			    type: 'warning'
			    }).then(async () => {
			        await this.cardsDel({id:data.id})
			        await this.getCardList()
			        this.$message({
			            type: 'success',
			            message:'删除成功',
			            duration: 3000
			        })
			    })
		},
		async httprequest(params) {
			params.limit = params.pageSize
			let res = await this.cardsList(params)
			console.log('res',res)
			return {total:res.count,data: res.list}
		}
	}
}
</script>
<style lang="less">
	 @classNames: cardList;
	.@{classNames}_operation_title {
			margin-right: 12px;
			color: #1989FA;
			font-size: 14px;
			cursor: pointer;
	}
</style>
